package cz.lhoracek.mapl.data.model

import kotlinx.serialization.Serializable

@Serializable
enum class GameType(val label: String, val multiplier: Int) {
    TRI("Tři", 1),
    CTYRI("Čtyři", 4),
    MAPL("Mapl", 8),
}

@Serializable
data class Round(
    val id: String,
    val sessionId: String,
    val actorId: String,
    val suit: Suit,
    val gameType: GameType,
    val flekLevel: Int,       // 0–6
    val won: Boolean,
    val timestamp: Long = 0L,
    val bet: Int = 0,         // snapshot of the session bet at the time this round was played
    val noCaller: Boolean = false,
) {
    val multiplier: Int get() = 1 shl flekLevel   // 2^flekLevel
}

val FLEK_NAMES = listOf("bez fleku", "flek", "re", "tutti", "boty", "kalhoty", "kaiser")

@Serializable
data class SessionWithPlayers(
    val session: Session,
    val players: List<Player>,
    val rounds: List<Round> = emptyList(),
)
